import { List } from 'lucide-react';
import { ElementType, MouseEvent } from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import FilterButton from '../../../FilterButton/FilterButton';

interface ColumnsVisibilityTriggerProps {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  testId?: string;
  icon?: ElementType;
  isActive?: boolean;
}

const ColumnsVisibilityTrigger = ({
  onClick,
  testId,
  icon = List,
  isActive,
}: ColumnsVisibilityTriggerProps) => {
  const { translate } = useTranslation();

  return (
    <FilterButton
      label={translate(LangEnum.GLOBAL_VIEW)}
      icon={icon}
      onClick={onClick}
      testId={testId}
      isActive={isActive}
    />
  );
};

export default ColumnsVisibilityTrigger;
